<template>
  <div class="page-footer">
    <!-- 友情链接栏 -->
    <div class="box_61 flex-row" style="margin-left: -3px;">
      <div 
        v-for="(link, index) in links"
        :key="'link' + link.id"
        class="link-item-wrapper flex-col justify-between"
        :class="{ 'link-item': link.url && link.url !== '#' }"
        :data-link-id="link.id"
        @mouseenter="onLinkMouseEnter(index, link)"
        @mouseleave="onLinkMouseLeave"
        @click.stop="handleLinkClick(link, index)"
      >
        <img
          class="link-icon"
          referrerpolicy="no-referrer"
          :src="link.imageUrl"
        />
        <span class="link-name">{{ link.name }}</span>
      </div>
      <!-- 图片链接弹层 -->
      <div
        v-if="showImagePopup && currentImagePopupLink"
        class="link-popup"
        @click.stop
      >
        <div class="link-popup-card" :style="popupPosition">
          <span class="link-popup-arrow"></span>
          <div class="link-popup-body">
            <img :src="currentImagePopupLink.url" :alt="currentImagePopupLink.name" />
            <span class="link-popup-desc">{{ currentImagePopupLink.name }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 政务服务栏 -->
    <div class="box_80 flex-row">
      <div class="box_38 flex-col">
        <div class="text-wrapper_30 flex-row">
          <span class="text_88">国家市场监督管理总局政务服务</span>
        </div>
        <div class="group_15 flex-row" >
          <a class="gov-item flex-col justify-between" v-for="(service) in services" :key="service.id" :href="service.url" target="_blank" rel="noopener noreferrer">
            <img class="gov-icon" referrerpolicy="no-referrer" :src="service.imageUrl" />
            <span class="gov-label" v-html="service.name"></span>
          </a>
        </div>
      </div>
    </div>
    <!-- 底部版权栏 -->
    <div class="box_62 flex-row">
      <router-link to="/" class="footer-logo-link">
        <img class="image_36" referrerpolicy="no-referrer" :src="require('../assets/img/FigmaDDSSlicePNG607ad099682ec6a3b46979a53ef9d1aa.png')" />
      </router-link>
      <div class="text-wrapper_29 flex-col">
        <span class="text_99">官方热线</span>
        <span class="text_100">{{ tel }}</span>
      </div>
      <div class="text-group_49 flex-col justify-between">
        <span class="text_101">
          <router-link to="/about-us" class="footer-link">关于我们</router-link>
          &nbsp;&nbsp;|&nbsp;&nbsp;
          <router-link to="/ad-service" class="footer-link">广告服务</router-link>
          &nbsp;&nbsp;|&nbsp;&nbsp;
          <router-link to="/copyright" class="footer-link">版权声明</router-link>
          &nbsp;&nbsp;|&nbsp;&nbsp;
          <router-link to="/contact-us" class="footer-link">联系我们</router-link>
        </span>
        <span class="paragraph_23"><span v-html="linkInfo"></span><br />
        <span v-html="filingInfo"></span></span>
      </div>
    </div>
  </div>
</template>

<script>
import request from '../api/request'

export default {
  name: 'PageFooter',
  watch: {
    showImagePopup(newVal) {
      console.log('[PageFooter] Popup visibility changed:', newVal)
    },
    currentImagePopupLink(newVal) {
      console.log('[PageFooter] Current image popup link:', newVal)
    }
  },
  data() {
    return {
      links: [],
      services: [],
      currentHoverLink: null,
      hoverIndex: -1,
      showImagePopup: false,
      currentImagePopupLink: null,
      popupPosition: {},
      lastClickedElement: null,
      tel: '010-64222825',
      linkInfo:'',
      filingInfo:'',
    }
  },
  created() {
    this.loadLinks()
    this.loadServices()
    this.showFooterInfo()
  },
  methods: {
    async loadLinks() {
      try {
        const res = await request.post('/api/index/getFriendLink')
        if (res.code === 200 && Array.isArray(res.data)) {
          this.links = res.data.map(item => ({ id: item.id, name: item.name, imageUrl: item.imageUrl, url: item.url }))
          console.log('[PageFooter] Loaded links:', this.links)
        }
      } catch (error) {
        console.error('加载友情链接失败', error)
      }
    },
    async showFooterInfo() {
      try {
         const content = await request.post('/api/index/getWebFooterInfo')
        this.tel = content.data.tel || '010-64222825'
        this.linkInfo = content.data.linkInfo || ''
        this.filingInfo = content.data.filingInfo || ''
      } catch (err) {
       
        this.orderPayTipContent = '<p>加载失败，请稍后重试</p>'
      } 
    },
    async loadServices() {
      try {
        const res = await request.post('/api/index/getGovernmentService')
        if (res.code === 200 && Array.isArray(res.data)) {
          this.services = res.data.map(item => ({ id: item.id, name: item.name, imageUrl: item.imageUrl, url: item.url }))
          console.log('[PageFooter] Loaded services:', this.services)
        }
      } catch (error) {
        console.error('加载友情链接失败', error)
      }
    },
    handleLinkClick(link, index) {
      console.log('[PageFooter] Click handler called', { link, index })
      if (!link.url || link.url === '#') return
      if (this.isImageUrl(link.url)) {
        console.log('[PageFooter] Image URL detected:', link.url)
        const idx = this.links.findIndex(l => l.id === link.id)
        if (idx >= 0) {
          const container = document.querySelector(`[data-link-id="${link.id}"]`)
          if (container) {
            this.lastClickedElement = container
            console.log('[PageFooter] Current element found:', container)
          }
        }
        this.showImagePopup = true
        this.currentImagePopupLink = link
        const element = this.lastClickedElement
        console.log('[PageFooter] Current element:', element)
        if (element) {
          const rect = element.getBoundingClientRect()
          const width =window.innerWidth
          if(width < 1400)
          {
            this.popupPosition = {
              top: `145px`,   // 加上页面纵向滚动偏移
              left: `${rect.left - 20}px`    // 加上页面横向滚动偏移
            }
          }
          else{
            console.log('[PageFooter] Screen width:', width)
            console.log('[PageFooter] Element rect:', rect)
            this.popupPosition = {
             top: `145px`,   // 加上页面纵向滚动偏移
             left: `${rect.left-((width-1400)/2)  - 20}px`    // 加上页面横向滚动偏移
            }
          }
        }
        return
      }
      this.openLink(link)
    },
    openLink(link) {
      if (!link.url || link.url === '#') return
      window.open(link.url, '_blank')
    },
    onLinkMouseEnter(index, link) {
      this.hoverIndex = index
      this.currentHoverLink = link
    },
    onLinkMouseLeave() {
      this.hoverIndex = -1
      this.currentHoverLink = null
    },
    isImageUrl(url) {
      console.log('[PageFooter] Checking if URL is image:', url)
      if (!url || url === '#') return false
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.svg']
      const lowerUrl = url.toLowerCase()
      if (lowerUrl.startsWith('http')) {
        const result = imageExtensions.some(ext => lowerUrl.endsWith(ext))
        console.log('[PageFooter] Image extension check for', lowerUrl, ':', result)
        return result
      }
      return false
    },
    closeImagePopup() {
      this.showImagePopup = false
      this.currentImagePopupLink = null
      this.lastClickedElement = null
    },
    handleDocumentClick(event) {
      const popup = event.target.closest('.link-popup')
      console.log('[PageFooter] handleDocumentClick', { event, popup })
      if (!popup && this.showImagePopup) {
        console.log('[PageFooter] Closing popup because clicked outside')
        this.closeImagePopup()
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleDocumentClick)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleDocumentClick)
  }
}
</script>

<style scoped>
/* ===== 政务服务图标 ===== */
.gov-icon {
  width: 48px;
  height: 48px;
}
.gov-item {
  align-items: center;
  text-decoration: none;
  cursor: pointer;
}
.gov-item:hover .gov-label {
  text-decoration: underline;
  color: #fff;
}
.gov-item:last-child {
  margin-right: 0;
}
.gov-label {
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  text-align: center;
  line-height: 20px;
  margin-top: 10px;
  font-family: Microsoft YaHei;
}

/* ===== 友情链接栏（13个平台）===== */
.box_61 {
  background-color: rgba(47, 47, 47, 1);
  width: 1400px;
  height: 169px;
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;   /* 改为 flex-start，第一个图标紧贴最左边 */
  align-items: flex-start;
  padding: 40px 0 0 0;
}
.box_61::before,
.box_61::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  width: calc((var(--viewport-width) - 1400px) / 2);
  background-color: rgba(47, 47, 47, 1);
}
.box_61::before {
  right: 100%;
}
.box_61::after {
  left: 100%;
}

/* 每个链接项 — 第一个紧贴左边，其余通过 margin-left: auto 均分剩余空间 */
.link-item-wrapper {
  width: 88px;
  height: 102px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}
/* 除第一个外，其余项使用 margin-left: auto 均分剩余空间，实现动态间隔 */
.link-item-wrapper:not(:first-child) {
  margin-left: auto;
}
.link-icon {
  width: 67px;
  height: 67px;
  display: block;
  margin: 0 auto;
}
.link-name {
  width: 88px;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  font-family: Microsoft YaHei-Regular;
  text-align: center;
  color: rgba(255, 255, 255, 1);
  overflow-wrap: break-word;
  margin-top: 5px;
}

/* ===== 政务服务栏 ===== */
.box_80 { width: 1400px; height: 288px; }
.box_38 {
  background-color: rgba(30, 30, 30, 1);
  height: 288px; width: 1400px; position: relative;
}
.box_38::before,
.box_38::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  width: calc((var(--viewport-width) - 1400px) / 2);
  background-color: rgba(30, 30, 30, 1);
}
.box_38::before { right: 100%; }
.box_38::after { left: 100%; }
.text-wrapper_30 { width: 408px; height: 45px; margin: 47px 0 0 508px; }
.text_88 {
  width: 408px; height: 45px; overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1); font-size: 34px;
  letter-spacing: 3px; font-family: Microsoft YaHei-Regular;
  text-align: left; white-space: nowrap; line-height: 34px;
}
.group_15 { width: 1371px; height: 99px; margin: 50px 0 47px 10px; justify-content: space-between; }

/* ===== 底部版权栏 ===== */
.box_62 {
  background-color: rgba(30, 30, 30, 1);
  width: 1400px; height: 140px;
  position: relative;
}
.box_62::before,
.box_62::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  width: calc((var(--viewport-width) - 1400px) / 2);
  background-color: rgba(30, 30, 30, 1);
}
.box_62::before { right: 100%; }
.box_62::after { left: 100%; }
.image_36 { width: 176px; height: 75px; margin: 23px 0 0 8px; }
.text-wrapper_29 {
  background-color: rgba(47, 47, 47, 1); border-radius: 14px;
  width: 240px; height: 101px;
  border: 1px solid rgba(82, 82, 82, 1);
  margin: 15px 0 0 18px;
}
.text_99 {
  width: 83px; height: 37px; overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1); font-size: 16px;
  font-family: Microsoft YaHei-Regular; text-align: center;
  line-height: 34px; margin: 9px 0 0 10px;
}
.text_100 {
  width: 194px; height: 40px; overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1); font-size: 30px;
  font-family: DIN Alternate-Bold; font-weight: 700;
  text-align: center; white-space: nowrap;
  line-height: 34px; margin: 0 0 15px 21px;
}
.text-group_49 { width: 886px; height: 108px; margin: 8px 17px 0 14px; }
.text_101 {
  width: 526px; height: 37px; overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1); font-size: 16px;
  font-family: Microsoft YaHei-Regular; text-align: right;
  line-height: 34px; margin-left: 360px;
}
.footer-link {
  color: rgba(255, 255, 255, 1);
  text-decoration: none;
  cursor: pointer;
  transition: opacity 0.2s;
}
.footer-link:hover {
  opacity: 0.7;
  text-decoration: underline;
}
.footer-logo-link {
  display: inline-block;
  cursor: pointer;
  transition: opacity 0.2s;
}
.footer-logo-link:hover {
  opacity: 0.8;
}
.link-item {
  cursor: pointer;
}
.link-item:hover .link-name {
  text-decoration: underline;
}

/* ===== 链接弹层样式 - 图片预览 ===== */
.link-popup {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;
  pointer-events: none;
}
.link-popup-card {
  position: absolute;
  background: rgba(255, 255, 255, 1);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  width: 140px;
  pointer-events: auto;
  display: inline-block;
}
.link-popup-arrow {
  content: '';
  position: absolute;
  bottom: calc(100% - 12px);
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  width: 20px;
  height: 20px;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: -2px -2px 6px rgba(0, 0, 0, 0.05);
}
.link-popup-body {
  padding: 14px 12px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.link-popup-body img {
  width: 110px;
  height: 110px;
  object-fit: contain;
  border-radius: 4px;
}
.link-popup-desc {
  font-size: 12px;
  color: #999;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
.paragraph_23 {
  width: 887px; height: 60px; overflow-wrap: break-word;
  color: rgba(204, 204, 204, 1); font-size: 14px;
  font-family: Microsoft YaHei-Regular; text-align: right;
  line-height: 30px; margin-top: 11px;
}
.paragraph_23 ::v-deep(a),
.paragraph_23 ::v-deep(a:visited),
.paragraph_23 ::v-deep(a:hover),
.paragraph_23 ::v-deep(a:active) {  
  color: inherit !important;
  text-decoration: underline !important;
}

/* 通用 flex 辅助类 */
.flex-row {
  display: flex;
  flex-direction: row;
}
.flex-col {
  display: flex;
  flex-direction: column;
}
.justify-between {
  justify-content: space-between;
}
</style>